<template>
  <div class="row q-col-gutter-x-md">
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Vehicle Cap Cost*</label>
      <q-field outlined :value="cost" :error="!isValid">
        <template #control>
          <currency-input @keypress.enter="validController" v-model="cost" class="q-field__input text-right abc-d" />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Lease Period(Month)*</label>
      <q-input
        @keypress.enter="validController"
        v-model="period"
        type="number"
        input-class="text-right abc-d"
        outlined
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val >= 1) || 'Period range 1-100 months'
        ]"
      ></q-input>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Depreciation*</label>
      <q-field outlined :value="depAmount" :error="!isValidDepAmount">
        <template #control>
          <currency-input
            @keypress.enter="validController"
            v-model="depAmount"
            class="q-field__input text-right abc-d"
          />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Monthly Lease Payment*</label>
      <q-field outlined :value="leaseAmount" :error="!isValidLeaseAmout">
        <template #control>
          <currency-input
            @keypress.enter="validController"
            v-model="leaseAmount"
            class="q-field__input text-right abc-d"
          />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div>
      <q-btn :loading="loading" color="primary" :disable="disableController || loading" @click="calculate"
        >Calculate</q-btn
      >
    </div>
  </div>
</template>
<script>
import round from 'lodash.round'
import axios from '../axios'
export default {
  methods: {
    validController() {
      !this.disableController ? this.calculate() : ''
    },
    async calculate() {
      this.show = false
      this.loading = true
      this.$store.commit('calculator/RESET_VALS', '')
      const body = {
        type: 'lease',
        amount: this.cost,
        period: parseInt(this.period),
        monthly_depreciation: this.depAmount,
        monthly_payment: this.leaseAmount
      }
      const { data } = await axios.post('calculator/finance', body)

      const { plan, monthly_interest_rate, payoff, annual_interest_rate } = data.data
      this.monthlyLeaseAmount = monthly_interest_rate
      this.annualLease = annual_interest_rate
      this.endLeaseTerm = payoff
      this.financeArr = plan
      this.loading = false
      this.show = true
    }
  },
  data() {
    return {
      loading: false,
      cost: 10000,
      period: 12,
      depAmount: 100,
      leaseAmount: 150
    }
  },
  computed: {
    annualLease: {
      get() {
        return this.$store.state.calculator.annualLease
      },
      set(val) {
        this.$store.commit('calculator/SET_ANNUAL_LEASE', val)
      }
    },
    financeArr: {
      get() {
        return this.$store.state.calculator.financeArr
      },
      set(val) {
        this.$store.commit('calculator/SET_PAYMENT_DETAILS', val)
      }
    },
    show: {
      get() {
        return this.$store.state.calculator.show
      },
      set(val) {
        this.$store.commit('calculator/SET_SHOW', val)
      }
    },
    monthlyLeaseAmount: {
      get() {
        return this.$store.state.calculator.monthlyLeaseAmount
      },
      set(val) {
        this.$store.commit('calculator/SET_MONTHLY_LEASE_AMOUNT', val)
      }
    },
    endLeaseTerm: {
      get() {
        return this.$store.state.calculator.endLeaseTerm
      },
      set(val) {
        this.$store.commit('calculator/SET_END_LEASE_TERM', val)
      }
    },
    disableController() {
      if (this.cost && this.period && this.period <= 100 && this.period > 0 && this.depAmount && this.leaseAmount)
        return false
      else return true
    },
    isValidLeaseAmout() {
      return this.leaseAmount
    },
    isValidDepAmount() {
      return this.depAmount
    },
    isValid() {
      return this.cost
    }
  }
}
</script>

<style lang="scss">
.abc-d {
  color: #000 !important;
}
.form-element-calculator {
  margin: 10px 0px;
}
.calculate-label {
  font-size: 15px;
  color: #027be3;
  font-weight: bold;
}
</style>
